export default {
    clearAll: 'Clear All',
    defaultTabExplore: 'Explore',
    defaultTabMissMFC: 'Miss MFC',
    defaultTabPopular: 'Popular',
    names: 'Names',
    offline: 'Offline',
    onlineNow: 'Online',
    search: 'Search',
    sorryNothingCameUpFor: 'Sorry, nothing came up for',
    sorryNothingCameUp: 'Sorry, nothing came up',
    tags: 'Tags',
    topics: 'Topics',
    explore: 'Explore',
    notBroadcasting: 'Not Broadcasting',
    tabs: {
        popular: 'Popular',
        exploreModels: 'Explore',
        trending: 'Trending',
        newModels: 'New',
        groupShows: 'Group Shows',
        missmfc: 'Miss MFC',
    },
}
